import React from "react";

export default class BuilderWorkspace extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className="BuilderWorkspace">{this.props.children}</div>;
  }
}
